export const TestModeList = ['preview', 'execution'] as const;
export type TestMode = (typeof TestModeList)[number];
